import { render, staticRenderFns } from "./UrgencyLabel.vue?vue&type=template&id=0f124f9c"
import script from "./UrgencyLabel.vue?vue&type=script&lang=ts"
export * from "./UrgencyLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports